import { IconName } from '@infotech-soe/erp-ui-kit';
import { ActionProcessMode } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommand from './CategoryCommand';

class OutputDocsCommand extends CategoryCommand<void | Record<string, any>> {
  public isAvailable(context: ClientContext): boolean {
    const id = context.get('Id');
    if (id === undefined) {
      return false;
    }
    const selected = context.get('SelectedIds');
    return (
      context.get('InParams')?.linksGraph?.mode !== DocLinksMode.SINGLE &&
      (!selected ||
        selected.length === 0 ||
        (selected.length === 1 && selected[0] === id))
    );
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.OUTPUT_DOCS,
    };
  }

  public getIcon(): IconName {
    return 'doclinks-out';
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.OUTPUT_DOCS,
    };
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }

  public getName(): string {
    return 'OutputDocs';
  }
}

export default OutputDocsCommand;
